
const initHeader = () => {

    const body = document.querySelector('body.page-template-tmpl-book-now');

    if (body) {
        const header = body.querySelector('header[data-elementor-type="header"]');
        if (header) {
            const langWrapper = header.querySelector('.elementor-element-5148992');
            const text = window.bookNowConfig?.book_now || 'Book Now';
            langWrapper.classList.add('book-now-styles');

            if (langWrapper) {
                langWrapper.insertAdjacentHTML('afterbegin', `
                    <button class="bn-btn bn-book-now-btn">${text}</button>
                `);
            }
        }
    }
}

const initButtons = () => {
    const btns = Array.from(document.querySelectorAll('.bn-book-now-btn'));

    btns.forEach(btn => {
        btn.addEventListener('click', () => {
            const bookNowSection = document.querySelector('.bn-form');
            if (bookNowSection) {
                bookNowSection.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });

}

const initClinicNoteCharacters = () => {
    const clinicNote = document.querySelector('.bn-form textarea[name="clinic_note"]');
    const characterCount = document.querySelector('.bn-form__clinic-note-characters');

    if (clinicNote && characterCount) {
        clinicNote.addEventListener('input', () => {
            characterCount.textContent = clinicNote.value.length;
        });
    }
}

const initLocationSelect = () => {
    const el = document.querySelector('.bn-form__form-item--location');
    if (!el) return;

    const form = el.closest('form');
    const select = el.querySelector('select');
    const provinceSections = [...form.querySelectorAll('.bn-form__form-item--province')];
    const locs = [...form.querySelectorAll('.bn-form__locs-item')];
    const locationRadioButtons = [...form.querySelectorAll('input[type="radio"][name="location"]')];

    // show locations by province on select change
    select.addEventListener('change', () => {
        const province = select.value;
        provinceSections.forEach((p) => {
            if (p.getAttribute('data-province') === province) {
                p.style.display = 'block';
            } else {
                p.style.display = 'none';
            }
        });

        // uncheck all location radio buttons
        locationRadioButtons.forEach(radio => {
            radio.checked = false;
        });
    });
}

const initSafety = () => {
    const el = document.querySelector('.bn-safety');
    if (!el) return;

    const top = el.querySelector('.bn-safety__top');

    top.addEventListener('click', () => {
        const active = el.classList.contains('active');
        if (el) {
            el.classList.toggle('active');
        }

        // scroll to bottom
        if (!active) {
            setTimeout(() => {
                el.classList.add('animating');
                document.addEventListener('scrollend', () => {
                    el.classList.remove('animating');
                }, { once: true });
                el.scrollIntoView({ behavior: 'smooth' });
            }, 10);
        }
    });

    window.addEventListener('scroll', () => {

        if (el.classList.contains('active') && !el.classList.contains('animating')) {
            const rect = top.getBoundingClientRect();
            console.log('top', rect);
            if (rect.top + rect.height > window.innerHeight) {
                el.classList.remove('active');
            }
        }
    });
}

const getRecaptchaToken = () => {
    const siteKey = window.bnRecaptchaSiteKey;

    if (!siteKey) {
        throw new Error('Missing reCAPTCHA site key.');
    }

    if (typeof grecaptcha === 'undefined') {
        throw new Error('reCAPTCHA is not loaded.');
    }

    return new Promise((resolve, reject) => {
        grecaptcha.ready(() => {
            grecaptcha.execute(siteKey, { action: 'book_now_submit' })
                .then(resolve)
                .catch(reject);
        });
    });
};

const initForm = () => {

    const form = document.querySelector('.bn-form__form');
    if (!form) return;

    const submit = form.querySelector('.bn-form__submit input[type="submit"]');
    const response = form.querySelector('.bn-form__response');

    form.addEventListener('submit', async (e) => {

        e.preventDefault();

        if ( submit.disabled ) return;

        response.classList.add('empty');
        response.textContent = '';
        submit.disabled = true;
        submit.value = window.bookNowConfig?.submitting || 'Submitting...';
        document.body.classList.add('bn-form-submitting');

        const token = await getRecaptchaToken();
        const formData = new FormData(form);
        formData.set('recaptcha_token', token);

        try {
            const res = await fetch(form.dataset.url, {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
            });

            const json = await res.json();

            if (json.success) {
                window.location.href = json.redirect;
            } else {
                const errors = json.errors || ['Something went wrong.'];

                errors.forEach(error => {
                    const p = document.createElement('p');
                    p.textContent = error;
                    response.appendChild(p);
                });

                response.classList.remove('empty');
                response.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        } catch (err) {
            console.log('error', err);
            response.classList.remove('empty');
            response.innerHTML = '<p>Something went wrong. Please try again.</p>';
            response.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        } finally {
            document.body.classList.remove('bn-form-submitting');
            submit.disabled = false;
            submit.value = window.bookNowConfig?.submit || 'Submit';
        }
    });

}

export default function bookNow() {
    initHeader();
    initButtons();
    initClinicNoteCharacters();
    initLocationSelect();
    initSafety();
    initForm();
}